export default {
  lang: "zh-TW",
  关于: "關於",
  角色: "角色",
  NFT: "NFT",
  币安顺风车: "币安顺风车",
  发布行程: "發布行程",
  获取最新资讯: "獲取最新資訊",
  立即加入社区: "立即加入社群",
  购买: "購買",
  "币安顺风车平台 是一个结合了区块链技术与绿色出行理念的创新项目。它通过顺风车、步行和公共交通等多种方式，让用户不仅享受便捷的出行，还可以赚取币安顺风车代币奖励，实现经济收益。凭借其多样化的奖励机制、NFT 系统和长期的代币分配模型，币安顺风车平台 为用户提供了一个独特的「边走边赚」的机会。展望未来，币安顺风车平台 有望成为区块链领域中出行类应用的先锋，吸引越来越多的用户加入并从中受益。在全球环境问题日益严重的背景下，币安顺风车平台 的绿色出行理念也符合可持续发展的趋势，既为用户带来便利，又为环境保护贡献力量。":
    "币安顺风车平台 是一個結合了區塊鏈技術與綠色出行理念的創新項目。它通過順風車、步行和公共交通等多種方式，讓用戶不僅享受便捷的出行，還可以賺取币安顺风车代幣獎勵，實現經濟收益。憑藉其多樣化的獎勵機制、NFT 系統和長期的代幣分配模型，币安顺风车平台 為用戶提供了一個獨特的「邊走邊賺」的機會。展望未來，币安顺风车平台 有望成為區塊鏈領域中出行類應用的先鋒，吸引越來越多的用戶加入並從中受益。在全球環境問題日益嚴重的背景下，币安顺风车平台 的綠色出行理念也符合可持續發展的趨勢，既為用戶帶來便利，又為環境保護貢獻力量。",
  "日常行程赚取 币安顺风车": "日常行程賺取 币安顺风车",
  "在 币安顺风车平台 项目中，用户可以通过完成顺风车、步行或使用公共交通来赚取 币安顺风车 代币。行程的奖励基于“打卡点”机制，奖励取决于打卡点的数量和每个打卡点的奖励值。":
    "在 币安顺风车平台 項目中，用戶可以通過完成順風車、步行或使用公共交通來賺取 币安顺风车 代幣。行程的獎勵基於「打卡點」機制，獎勵取決於打卡點的數量和每個打卡點的獎勵值。",
  单个行程的奖励规则: "單個行程的獎勵規則",
  "奖励计算公式：行程奖励 = 打卡点数量 × 单个打卡点奖励值":
    "獎勵計算公式：行程獎勵 = 打卡點數量 × 單個打卡點獎勵值",
  "单个打卡点奖励值：公式：个人奖励基数 × (个人质押数量÷10,000)¹/⁴ 说明：个人奖励基数随全网总质押量动态变化调整，且全网每日奖励总额上限为 5,120 枚。":
    "單個打卡點獎勵值：公式：個人獎勵基數 × (個人質押數量÷10,000)¹/⁴。\n說明：個人獎勵基數會隨全網總質押量動態變化調整，全網每日獎勵總額上限為 5,120 枚。",
  顺风车司机: "順風車司機",
  "每日可获得额外 2 个行程次数": "每日可獲得額外 2 個行程次數",
  出行达人: "出行達人",
  "每日可获得 5 个额外行程次数": "每日可獲得 5 個額外行程次數",
  车队老板: "車隊老闆",
  "每日可获得 100 个额外行程次数，可以将行程次数赠送给好友":
    "每日可獲得 100 個額外行程次數，可以將行程次數贈送給好友",
  城市合伙人: "城市合夥人",
  "每日可获得 1000 个额外行程次数，可以将行程次数赠送给好友":
    "每日可獲得 1000 個額外行程次數，可以將行程次數贈送給好友",
  车主汽车NFT: "車主汽車NFT",
  新星之驾: "新星之駕",
  银翼之旅: "銀翼之旅",
  金辉之路: "金輝之路",
  耀世之行: "耀世之行",
  传奇之旅: "傳奇之旅",
  非车主服饰NFT: "非車主服飾NFT",
  普通款: "普通款",
  晨曦之装: "晨曦之裝",
  霞光之服: "霞光之服",
  月华之衣: "月華之衣",
  日曜之袍: "日曜之袍",
  免费: "免費",
  打点奖励基数: "打點獎勵基數",
  "币安顺风车 Token 简介": "Binance相乗りトークン（Token）概要",
  "概述 币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。 核心参数 • 代币标准：BEP-20（BSC） • 最大供应：1,000,000,000 • 启动即焚毁：700,000,000（链上可查） • 启动后剩余供应：300,000,000（其中 200,000,000 锁定用于行程挖矿奖励，非流通） 产出与奖励机制 • 行程奖励=打卡点数量 × 单个打卡点奖励值 • 单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4) • 个人奖励基数随全网总质押量动态调整 • 全网单日奖励总上限：5,120 枚 公平发射与官方参与 • 零预售、零预留、零私募；全程公开透明 • 官方通过 four.meme 公平购入 218,888,888 枚： – 200,000,000 枚锁入智能合约用于“行程挖矿” – 10,000,000 枚用于平台内积分兑换 – 8,888,888 枚用于社区活动与生态激励 • 绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查 团队长计划 • 全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB • 预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰 • 公平发射分配（核心 60,000,000 枚）： – 42,000,000 枚按投入比例分配 – 18,000,000 枚作为“团队长特殊贡献奖” • 前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权 团队长计划官方唯一地址： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 代币用途与价值 • 出行激励：完成有效行程获得代币 • 权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等 • 生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "概述 幣安順風車是一個將區塊鏈與綠色出行結合的應用型項目，用戶可透過順風車、步行、公共交通等日常出行方式獲取代幣獎勵，實現「邊走邊賺」的概念。項目堅持公平發射與全鏈透明，強調長期激勵與可持續的生態發展。 核心參數 • 代幣標準：BEP-20（BSC） • 最大供應量：1,000,000,000 • 啟動即銷毀：700,000,000（鏈上可查） • 啟動後剩餘供應量：300,000,000（其中 200,000,000 鎖定用於行程挖礦獎勵，非流通） 產出與獎勵機制 • 行程獎勵 = 打卡點數量 × 單個打卡點獎勵值 • 單個打卡點獎勵值 = 個人獎勵基數 × (個人質押數量 ÷ 10,000)^(1/4) • 個人獎勵基數會隨全網總質押量動態調整 • 全網每日獎勵總上限：5,120 枚 公平發射與官方參與 • 零預售、零預留、零私募；全程公開透明 • 官方透過 four.meme 公平購入 218,888,888 枚： – 200,000,000 枚鎖入智能合約用於「行程挖礦」 – 10,000,000 枚用於平台內積分兌換 – 8,888,888 枚用於社群活動與生態激勵 • 綁定曲線機制會隨購入自動抬價，官方與社群以同價入場，鏈上可查 團隊長計劃 • 全球限量招募 100 位團隊長：每人 0.7 BNB，總額 70 BNB • 預計可購約 7.6 億枚，其中 7 億枚將立即銷毀；稀缺結構明確 • 公平發射分配（核心 60,000,000 枚）： – 42,000,000 枚按投入比例分配 – 18,000,000 枚作為「團隊長特殊貢獻獎」 • 前 100 名可獲「車隊老闆」1 個月身份（不含任何分紅），享平台內次數增益、贈送權限、專屬徽章與活動優先權 團隊長計劃官方唯一地址： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 代幣用途與價值 • 出行激勵：完成有效行程可獲代幣獎勵 • 權益與兌換：可用於平台積分兌換、活動激勵及 NFT 權益結合 • 生態成長：圍繞順風出行的多場景應用，鼓勵真實出行與綠色低碳行為",
  "在STON.FI上购买": "在STON.FI上購買",

  概述: "概述",
  "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。":
    "幣安順風車是將區塊鏈與綠色出行結合的應用型項目，用戶透過順風車、步行、公共交通等日常出行獲取代幣獎勵，實現「邊走邊賺」。項目堅持公平發射與全鏈透明，強調長期激勵與可持續的生態增長。",
  核心参数: "核心參數",
  "代币标准：BEP-20（BSC）": "代幣標準：BEP-20（BSC）",
  "最大供应：1,000M": "最大供應：1,000M",
  "启动即焚毁：432.46M（链上可查）": "啟動即焚毀：432.46M（鏈上可查）",
  "启动后剩余供应：567M": "啟動後剩餘供應：567M",
  "– 其中 200M 锁定用于行程挖矿奖励，非流通":
    "– 其中 200M 鎖定用於行程挖礦獎勵，非流通",
  "– 其中 10M 锁定用于积分兑换等": "– 其中 10M 鎖定用於積分兌換等",
  产出与奖励机制: "產出與獎勵機制",
  "行程奖励=打卡点数量 × 单个打卡点奖励值":
    "行程獎勵 = 打卡點數量 × 單個打卡點獎勵值",
  "单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)":
    "單個打卡點獎勵值 = 個人獎勵基數 × (個人質押數量 ÷ 10,000)^(1/4)",
  个人奖励基数随全网总质押量动态调整: "個人獎勵基數隨全網總質押量動態調整",
  "全网单日奖励总上限：5,120 枚": "全網單日獎勵總上限：5,120 枚",
  公平发射与官方参与: "官方參與公平發射",
  "零预售、零预留、零私募；全程公开透明":
    "零預售、零預留、零私募；全程公開透明",
  "官方通过 four.meme 公平购入 210M 枚：":
    "官方通過 four.meme 公平購入 210M 枚：",
  "– 200M 枚锁入智能合约用于“行程挖矿”":
    "– 200M 枚鎖入智能合約用於「行程挖礦」",
  "– 10M 枚用于平台内积分兑换": "– 10M 枚用於平台內積分兌換",
  "– 8,888,888 枚用于社区活动与生态激励":
    "– 8,888,888 枚用於社群活動與生態激勵",
  "绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查":
    "綁定曲線機制隨購入自動抬價，官方與社區同價入場、鏈上可查",
  团队长计划: "團隊長計畫",
  "全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB":
    "全球限量招募 100 位團隊長：每人 0.7 BNB，總額 70 BNB",
  "预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰":
    "預計可購約 7.6 億枚，其中 7 億枚將立即銷毀；稀缺結構清晰",
  "公平发射分配（核心 60,000,000 枚）：":
    "公平發射分配（核心 60,000,000 枚）：",
  "– 42,000,000 枚按投入比例分配": "– 42,000,000 枚按投入比例分配",
  "– 18,000,000 枚作为“团队长特殊贡献奖”":
    "– 18,000,000 枚作為「團隊長特殊貢獻獎」",
  "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权":
    "前 100 名獲「車隊老闆」1 個月身份（不含任何分紅），享平台內次數增益、贈送權限、專屬徽章與活動優先權",
  "团队长计划官方唯一地址：": "團隊長計畫官方唯一地址：",
  代币用途与价值: "代幣用途與價值",
  "出行激励：完成有效行程获得代币": "出行激勵：完成有效行程獲得代幣",
  "权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等":
    "權益與兌換：用於平台積分兌換、活動激勵、NFT 權益配合等",
  "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "生態成長：圍繞順風出行的多場景應用，鼓勵真實出行與綠色低碳行為",
};
